
<template>
  <div class="check-list-form" @click="onPageClick">
      <div class="box">
        <div class="columns is-multiline">
          <div class="column is-9">
            <b-field label="Name">
              <b-input v-model="editCheckList.name" aria-placeholder="name" />
          </b-field>
          </div>
          <div class="column is-3">
            <div class="field">
              <label class="label">&nbsp;</label>
              <b-checkbox v-model="editCheckList.requiresSmu">
                Requires SMU Entered
              </b-checkbox>
            </div>
          </div>
          <div class="column is-12">
            <b-field label="Description / Notes">
              <b-input type="textarea" v-model="editCheckList.description" />
            </b-field>
          </div>
        </div>
      </div>

      <h1 class="flex-1 title is-4">List Items</h1>

      <template v-for="(check, i) in editCheckList.checks">
        <div class="box check-container pointer" :class="{editing: i === editIndex}" :key="i + '-box'" @click="editCheck(i)">
          <div class="check-number">
            Check {{ i + 1 }}

            <span v-if="i > 0" @click.stop="moveUp(i)"><font-awesome-icon icon="chevron-up" /></span>
            <span v-if="i < editCheckList.checks.length - 1" @click.stop="moveDown(i)"><font-awesome-icon icon="chevron-down" /></span>

            <span v-if="i === editIndex" style="float: right">
              <a class="delete" @click="removeCheck(i)"></a>
            </span>
          </div>

          <div v-if="i !== editIndex" class="pointer flex hover">
            <div class="flex-1">
              <!-- <h2 class="subtitle">{{ check.type }} </h2> -->
              <h1 class="title is-5">{{ check.name ? check.name : 'NO DESCRIPTION ENTERED' }}</h1>
            </div>
            <font-awesome-icon icon="edit" />
          </div>

          <div v-else class="columns is-multiline">
            <div class="column is-9">
              <b-field label="">
                <b-input v-model="check.name" placeholder="Enter list item decription" />
              </b-field>
            </div>
            <div class="column is-3">
              <b-field label="">
                <b-select placeholder="Select a type" v-model="check.type">
                  <option v-for="option in checkTypes" :value="option" :key="option">
                    {{ option }}
                  </option>
                </b-select>
              </b-field>
            </div>

            <div class="column is-3" v-if="check.type === 'text' || check.type === 'number'">
              <b-field :label="`Mandatory ${check.type} input`">
                <b-checkbox v-model="check.mandatory">
                  {{ check.mandatory ? 'Yes' : 'No'}}
                </b-checkbox>
              </b-field>
            </div>

            <div class="column is-3" v-if="check.type === 'checkbox'">
              <b-field label="Allow NA option">
                <b-checkbox v-model="check.allowNa">
                  {{ check.allowNa ? 'Yes' : 'No'}}
                </b-checkbox>
              </b-field>
            </div>

            <div class="column is-3" v-if="check.type !== 'text'">
              <b-field label="Show comments input">
                <b-checkbox v-model="check.showComment">
                  {{ check.showComment ? 'Yes' : 'No'}}
                </b-checkbox>
              </b-field>
            </div>

            <div class="column is-3" v-if="check.type === 'checkbox' && check.showComment">
              <b-field label="Must comment if un-checked">
                <b-checkbox v-model="check.requiredIfFalse">
                  {{ check.showComment ? 'Yes' : 'No'}}
                </b-checkbox>
              </b-field>
            </div>
          </div>

        </div>
        <div class="text-center pad" :key="i + 'button'">
          <button class="button is-small" @click.stop="addCheck(i)">
            <font-awesome-icon icon="plus" />
          </button>
        </div>
      </template>

      <div class="pad text-center has-text-grey-light" v-if="!editCheckList.checks.length">
        There are no list items
        <br />
        <br />
        <button class="button is-small" @click.stop="addCheck()">
          <font-awesome-icon icon="plus" />
        </button>
      </div>

      <br /><br />

      <b-notification v-if="errArr.length" :active.sync="showErrs" type="is-danger">
        <p v-for="(msg, i) in errArr" :key="i">{{ msg }}</p>
      </b-notification>

      <div class="buttons">
        <button class="button is-info" :class="{'is-loading': submitting}" @click="submit">{{ isNew ? 'Add' : 'Update' }} Check list</button>
      </div>
  </div>
</template>

<script>
import { CheckListsHelper } from '@/utils/checkLists.js'
export default {
  name: 'CheckListForm',
  props: ['checkList'],
  data () {
    return {
      editCheckList: null,
      submitting: false,
      errArr: [],
      checkTypes: [
        'checkbox',
        'number',
        'text'
      ],
      editIndex: null,
      showErrs: false
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    isNew () { return !this.checkList },
    checks () { return this.editCheckList.checks }
  },
  watch: {
    checkList () { this.prepareCheckList() },
    errArr () {
      this.showErrs = this.errArr.length > 0
    }
  },
  created () {
    this.prepareCheckList()
  },
  methods: {
    onPageClick (e) {
      let el = e.target
      while (el) {
        if (el.classList.contains('check-container')) {
          return
        }
        el = el.parentElement
      }
      this.editIndex = -1
    },
    addCheck (i = false) {
      if (i === false) {
        this.checks.push(this.getBlankCheck())
        this.editIndex = this.checks.length - 1
      } else {
        this.checks.splice(i + 1, 0, this.getBlankCheck())
        this.editIndex = i + 1
      }
    },
    editCheck (i) {
      if (this.editIndex !== i) {
        this.editIndex = i
      }
    },
    moveUp (i) {
      let check = this.checks[i]
      this.checks.splice(i, 1)
      this.checks.splice(i - 1, 0, check)
    },
    moveDown (i) {
      let check = this.checks[i]
      this.checks.splice(i, 1)
      this.checks.splice(i + 1, 0, check)
    },
    removeCheck (i) {
      this.checks.splice(i, 1)
    },
    validate () {
      this.errArr = []
      for (let check of this.checks) {
        if (check.type === 'checkbox') {
          check.mandatory = true
        }
      }
      if (!this.editCheckList.name.length) {
        this.errArr.push('Please enter a name')
      }
      if (!this.editCheckList.checks.length) {
        this.errArr.push('No checks added to this list')
      }
      return this.errArr.length === 0
    },
    submit () {
      if (!this.validate() || this.submitting) {
        return
      }
      this.submitting = true
      if (this.isNew) {
        this.$firestore.collection('checkLists')
          .add(this.editCheckList)
          .then(this.submitComplete)
          .catch(this.submitError)
      } else {
        delete this.editCheckList._id
        this.$firestore.collection('checkLists')
          .doc(this.checkList._id)
          .set(this.editCheckList)
          .then(this.submitComplete)
          .catch(this.submitError)
      }
    },
    submitComplete (resp) {
      this.$toast.open({
        message: `Pre Start Check List ${this.isNew ? 'Added' : 'Updated'}`,
        type: 'is-info'
      })
      this.submitting = false
      this.$emit('submitted', this.isNew ? resp.id : this.checkList._id)
    },
    submitError (err) {
      this.submitting = false
      this.errArr.push(err.toString())
    },
    prepareCheckList () {
      this.editCheckList = Object.assign(this.getBlankCheckList(), this.checkList || {})
    },
    getBlankCheckList () {
      return CheckListsHelper.getBlankCheckList()
    },
    getBlankCheck () {
      return CheckListsHelper.getBlankCheck()
    }
  }
}
</script>

<style>
  .check-list-form {
    height: 100%;
  }

  .check-list-form .box.check-container {
    margin: 0;
    background-color: #eee;
  }

  .check-list-form .box.check-container.editing {
    border: solid 1px #209cee;
    cursor: default;
  }

  .check-list-form .check-number {
    font-weight: bold;
    margin: -10px 0 10px -10px;
    color: #999;
  }
  .check-list-form .check-number span {
    padding-left: 20px;
  }
</style>
